import { render, staticRenderFns } from "./prestoreAccount.vue?vue&type=template&id=633f23ac&scoped=true"
import script from "./prestoreAccount.vue?vue&type=script&lang=js"
export * from "./prestoreAccount.vue?vue&type=script&lang=js"
import style0 from "./prestoreAccount.vue?vue&type=style&index=0&id=633f23ac&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_a6c7c6c484daeff6636bea47b922569f/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "633f23ac",
  null
  
)

export default component.exports